import ExternalApplicationCard from './ExternalApplicationCard';
import ExternalApplicationListItem from './ExternalApplicationListItem';
import { RenderModeEnum } from '../../../../utils/widgets';
import { useWidgetExternalApplicationsContext } from '../utils/context';

type ExternalApplicationItemProps = {
	name: string;
	imageSrc?: string;
	disabled?: boolean;
	disabledMessage?: string;
};

const ExternalApplicationItem = ({ name, imageSrc, disabled, disabledMessage }: ExternalApplicationItemProps) => {
	const { renderMode } = useWidgetExternalApplicationsContext();

	return renderMode === RenderModeEnum.LIST ? (
		<ExternalApplicationListItem
			name={name}
			disabled={disabled}
			disabledMessage={disabledMessage}
			imageSrc={imageSrc}
		/>
	) : (
		<ExternalApplicationCard name={name} imageSrc={imageSrc} disabled={disabled} disabledMessage={disabledMessage} />
	);
};

export default ExternalApplicationItem;
